module.exports = __webpack_public_path__ + "static/media/fireplace.9eebaf66.svg";